
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/[locationSlug]",
      function () {
        return require("private-next-pages/services/[locationSlug]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/[locationSlug]"])
      });
    }
  